import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class MeetSchedulesAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllMeetingSchedules(router){
    const url = `/api/meetSchedules`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getAllMeetingSchedulesForFlightSchool(schoolId, router){
    const url = `/api/meetSchedules/school/${schoolId}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getMeetingScheduleById(id, router) {
    const url = `/api/meetSchedules/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createMeetSchedule(params, router) {
    const url = `/api/meetSchedules`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateMeetSchedule(id, params, router) {
    const url = `/api/meetSchedules/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteMeetSchedule(id, router) {
    const url = `/api/meetSchedules/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

}
export default MeetSchedulesAPIService;
